module.exports = __webpack_public_path__ + "img/lg_ring_y_i_1_0.77b97fe0.png";